var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40.738,
    viewBox: "0 0 22.523 40.738",
    width: 22.523,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.75 43.883v-12.614a2.1 2.1 0 1 1 4.2 0v7.008",
    transform: "translate(-38.795 -27.015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.25 26.837v-1.4a2.1 2.1 0 1 1 4.2 0v1.4",
    transform: "translate(-52.091 -22.583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.75 38.277v-7.008a2.1 2.1 0 0 1 4.2 0v2.8",
    transform: "translate(-65.387 -27.015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.068 48.542v-5.606a2.1 2.1 0 0 1 4.2 0v12.613a7.008 7.008 0 0 1 -7.008 7.008h-4.669c-5.137 0-9.341-5.606-9.341-8.409v-5.606a2.1 2.1 0 0 1 2.1-2.1h2.1",
    transform: "translate(-25.5 -35.878)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.588 35.976-3.393-3.393a.848.848 0 1 0 -1.2 1.2l1.944 1.945h-10.039l1.944-1.945a.848.848 0 0 0 -1.2-1.2l-3.393 3.393a.847.847 0 0 0 0 1.2l3.393 3.393a.848.848 0 0 0 1.2-1.2l-1.944-1.945h10.04l-1.94 1.945a.848.848 0 0 0 1.2 1.2l3.393-3.393a.847.847 0 0 0 0-1.2z",
    fill: "currentcolor",
    transform: "translate(3.747 -.058)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipe);
export default __webpack_public_path__ + "static/media/swipe.df8bac64c085a3aef8d64885675c4e32.svg";
export { ForwardRef as ReactComponent };